import React, { useState, useEffect } from "react";
import SwipeableViews from "react-swipeable-views";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import { Box, Tabs, Tab, Typography, Grid, IconButton, Tooltip } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { GiCancel } from "react-icons/gi";
import GetAppIcon from "@mui/icons-material/GetApp";

import LocalizationTable from "./LocalizationTable";
import LocalizationExcelToList from "./LocalizationExcelToList";
import { FaUpload } from "react-icons/fa";
import LoadingBackdrop from "../../components/LoadingBackdrop/LoadingBackdrop";

import { postExcelUpload, downloadExcelFile } from "../../store/actions/LocalizationDataActions";

export default function LocalizationDataUpload() {
    const ls = localStorage;
    const theme = useTheme();
    const [tabIndexValue, setTabIndexValue] = useState(parseInt(ls.getItem("localization_tabValue")) || 0);
    const { t } = useTranslation("translation");
    const dispatch = useDispatch();

    const { uploadResponse } = useSelector(({ LocalizationData }) => LocalizationData);

    const [breakdownDetailExcel, setBreakdownDetailExcel] = useState([]);
    const [breakdownEffectExcel, setBreakdownEffectExcel] = useState([]);
    const [breakdownReasonGroupExcel, setBreakdownReasonGroupExcel] = useState([]);
    const [breakdownReasonPlaceExcel, setBreakdownReasonPlaceExcel] = useState([]);
    const [breakdownRootCauseExcel, setBreakdownRootCauseExcel] = useState([]);

    const [formData, setFormData] = useState(new FormData());
    const [warningList, setWarningList] = useState([]);

    const [disableExcel, setDisableExcel] = useState(false);
    const [disableUpload, setDisableUpload] = useState(true);
    const [disableCancel, setDisableCancel] = useState(true);

    const [tabId, setTabId] = useState();

    useEffect(() => {
        if (uploadResponse?.data) {
            setWarningList([]);
            setFormData(new FormData());
            setDisableUpload(true);
            setDisableExcel(false);
            setDisableCancel(true);
        }
    }, [uploadResponse]);

    const TabPanel = (props) => {
        const { children, value, index, ...other } = props;

        return (
            <Typography component="div" role="tabpanel" hidden={value !== index} id={`scrollable-auto-tabpanel-${index}`} aria-labelledby={`scrollable-auto-tab-${index}`} {...other}>
                <Box>{children}</Box>
            </Typography>
        );
    };

    const handleChange = (_event, newValue) => {
        setTabIndexValue(newValue);
        ls.setItem("localization_tabValue", newValue);
    };

    const cancelUpload = () => {
        setWarningList([]);
        setDisableCancel(true);
        setDisableExcel(false);
        window.location.reload();
    };

    const uploadExcel = () => {
        let payload = {
            data: formData,
            tabId: tabId,
        };

        dispatch(postExcelUpload(payload));
    };

    const callBackTabData = (_tabId, excelData) => {
        if (excelData.excelList.errorCode === 0) {
            if (_tabId == 0) {
                setBreakdownDetailExcel(excelData.excelList.resultObject);
            } else if (_tabId == 1) {
                setBreakdownEffectExcel(excelData.excelList.resultObject);
            } else if (_tabId == 2) {
                setBreakdownReasonGroupExcel(excelData.excelList.resultObject);
            } else if (_tabId == 3) {
                setBreakdownReasonPlaceExcel(excelData.excelList.resultObject);
            } else {
                setBreakdownRootCauseExcel(excelData.excelList.resultObject);
            }

            setTabId(_tabId);
            setDisableExcel(true);
            setDisableCancel(false);
            setDisableUpload(false);

            if (excelData.excelList.resultObject.warnings?.length > 0) {
                setWarningList(excelData?.excelList.resultObject.warnings);
            }
        }
    };

    const a11yProps = (index) => {
        return {
            id: `scrollable-auto-tab-${index}`,
            "aria-controls": `scrollable-auto-tabpanel-${index}`,
        };
    };

    return (
        <div>
            <Grid container item md={12}>
                {/* Tabs */}
                <Grid item xs={12} sm={12} md={12} lg={12}>
                    <Tabs value={tabIndexValue} onChange={handleChange} centered>
                        <Tab label={t("BreakdownDetail")} {...a11yProps(0)}></Tab>
                        <Tab label={t("BreakdownEffect")} {...a11yProps(1)}></Tab>
                        <Tab label={t("BreakdownGroup")} {...a11yProps(2)}></Tab>
                        <Tab label={t("BreakdownPlace")} {...a11yProps(3)}></Tab>
                        <Tab label={t("BreakdownRootCause")} {...a11yProps(4)}></Tab>
                    </Tabs>
                </Grid>

                {/* Empty grid */}
                <Grid item xs={1} sm={3} md={4} lg={4}></Grid>

                {/* Buttons */}
                <Grid item xs={12} sm={6} md={12} lg={4}>
                    {/* Excel File Outline */}
                    <Tooltip title={t("ExcelFileOutline")}>
                        <IconButton
                            onClick={() =>
                                dispatch(
                                    downloadExcelFile({tabId: tabIndexValue, data: {}})
                                )
                            }
                            size="large">
                            <GetAppIcon style={{ color: "#008000", width: 50, height: 50 }} />
                        </IconButton>
                    </Tooltip>

                    {/* Excel Butonu */}
                    <Tooltip title={t("ChooseExcelFile")}>
                        <IconButton component="label" disabled={disableExcel} size="large">
                            <LocalizationExcelToList
                                callBackTabData={callBackTabData}
                                setFormData={setFormData}
                                disableExcel={disableExcel}
                                tabId={tabIndexValue} //tabId to upload correct api endpoint
                            />
                        </IconButton>
                    </Tooltip>

                    {/* İptal Butonu */}
                    <Tooltip title={t("Cancel")}>
                        <IconButton
                            component="label"
                            onClick={cancelUpload}
                            disabled={disableCancel}
                            size="large">
                            <GiCancel style={{ width: 50, height: 50, padding: 0, fill: disableCancel ? "#bdbdbd" : "#E82114" }} />
                        </IconButton>
                    </Tooltip>

                    {/* Upload Butonu */}
                    <Tooltip title={t("DataUpload")}>
                        <IconButton component="label" disabled={disableUpload} size="large">
                            <FaUpload disableUpload={disableUpload} style={{ fill: disableUpload ? "#bdbdbd" : "#00a4b9", width: "50px", height: "50px", padding: "0px" }} onClick={uploadExcel} />
                        </IconButton>
                    </Tooltip>
                </Grid>
            </Grid>

            <SwipeableViews
                axis={theme.direction === "rtl" ? "x-reverse" : "x"}
                index={tabIndexValue}
                onChangeIndex={(value) => {
                    setTabIndexValue(value);
                }}
                enableMouseEvents
            >
                {/* callback function'dan gelen data ilgili komponente props olarak gidip tabloyu doldurur */}
                <TabPanel value={tabIndexValue} index={0} dir={theme.direction}>
                    <LocalizationTable localizationExcel={breakdownDetailExcel} warningList={warningList} />
                </TabPanel>
                <TabPanel value={tabIndexValue} index={1} dir={theme.direction}>
                    <LocalizationTable localizationExcel={breakdownEffectExcel} warningList={warningList} />
                </TabPanel>
                <TabPanel value={tabIndexValue} index={2} dir={theme.direction}>
                    <LocalizationTable localizationExcel={breakdownReasonGroupExcel} warningList={warningList} />
                </TabPanel>
                <TabPanel value={tabIndexValue} index={3} dir={theme.direction}>
                    <LocalizationTable localizationExcel={breakdownReasonPlaceExcel} warningList={warningList} />
                </TabPanel>
                <TabPanel value={tabIndexValue} index={4} dir={theme.direction}>
                    <LocalizationTable localizationExcel={breakdownRootCauseExcel} warningList={warningList} />
                </TabPanel>
            </SwipeableViews>
            <LoadingBackdrop />
        </div>
    );
}
